import { Box, HStack, VStack } from "@chakra-ui/react";

export default function PlayingCardBack() {
  const sideLength = "33.5px";
  const cardRed = "#E43D4D";
  const cardPink = "#E6A9EB";
  return (
    <VStack w="100px" h="168px" bg="#E6A9EB" borderRadius="lg" spacing="0px">
      <HStack minH={sideLength} w="100%" spacing="0px">
        <Box
          minH={sideLength}
          minW={sideLength}
          bg={cardRed}
          borderTopLeftRadius="lg"
        />
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
        <Box
          minH={sideLength}
          minW={sideLength}
          bg={cardRed}
          borderTopRightRadius="lg"
        />
      </HStack>
      <HStack minH={sideLength} w="100%" spacing="0px">
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
        <Box minH={sideLength} minW={sideLength} bg={cardRed} />
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
      </HStack>
      <HStack minH={sideLength} w="100%" spacing="0px">
        <Box minH={sideLength} minW={sideLength} bg={cardRed} />
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
        <Box minH={sideLength} minW={sideLength} bg={cardRed} />
      </HStack>
      <HStack minH={sideLength} w="100%" spacing="0px">
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
        <Box minH={sideLength} minW={sideLength} bg={cardRed} />
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
      </HStack>
      <HStack minH={sideLength} w="100%" spacing="0px">
        <Box
          minH={sideLength}
          minW={sideLength}
          bg={cardRed}
          borderBottomLeftRadius="lg"
        />
        <Box minH={sideLength} minW={sideLength} bg={cardPink} />
        <Box
          minH={sideLength}
          minW={sideLength}
          bg={cardRed}
          borderBottomRightRadius="lg"
        />
      </HStack>
    </VStack>
  );
}
